<template>
  <ObjectListTabs>
    <template slot-scope="{}">
        <b-nav-item :to="{name: 'artist-profile-edit'}">Artist info</b-nav-item>
        <b-nav-item :to="{name: 'artist-my-activity'}">Manage activity</b-nav-item>
        <b-nav-item :to="{name: 'artist-blocked-users'}">Blocked users</b-nav-item>
        <b-nav-item :to="{name: 'artist-payout-method'}">Payout settings</b-nav-item>
    </template>
  </ObjectListTabs>
</template>

<script>
import ObjectListTabs from '@/components/widgets/ObjectListTabs'

export default {
  name: 'ArtistEditProfileTabs',
  components: { ObjectListTabs }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/ArtistEditProfileTabs.vue